import { BuilderRegrasComuns } from './builderRegrasComuns';

export const buscarRegrasComuns = (valoresForm,arrayMsgsErro,dependentes,plano) => {
    try {
        const correnteRegrasComum = new BuilderRegrasComuns(
            valoresForm,
            arrayMsgsErro,
            dependentes?.length,
            plano
        )
            .permitirSemAdicionalMenor18anos();
        const { arrayRegrasComum } = correnteRegrasComum;
    
        return arrayRegrasComum;
    } catch (error) {
        console.log(error);
    }
};